import api from '@/api/zkbio-setting'

export const state = {
  resource: {}
}

export const getters = {}

export const mutations = {
  RECEIVE_RESOURCES(state, data) {
    state.resource = data
  }
}

export const actions = {
  fetch(context) {
    return api.get().then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response.data)
    })
  },

  store(context, data) {
    return api.store(data)
  }
}
